import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check, CalendarClock, Sparkles, Mail } from "lucide-react";

const PLAN_BENEFITS = [
  "Unlimited menu items per outlet",
  "Branded QR code per outlet",
  "Real-time menu updates",
  "Veg / Non-Veg / Jain & dietary tags",
  "Bulk import from Excel",
];

export function RestaurantPlanCard({ plan, isCurrent, busy, disabled, onBuy, sym }) {
  return (
    <Card
      className={`p-6 border ${isCurrent ? "border-brand-orange ring-2 ring-brand-orange/30" : "border-border"} flex flex-col`}
      data-testid={`plan-card-${plan.id}`}
    >
      <div className="text-xs uppercase tracking-[0.2em] font-bold text-brand-orange mb-2">{plan.label}</div>
      <div className="font-heading font-extrabold text-3xl">{sym}{plan.amount}</div>
      <div className="text-xs text-muted-foreground mb-4">/year</div>
      <ul className="text-sm space-y-1.5 text-foreground/70 mb-5 flex-1">
        <li className="flex items-start gap-2">
          <Check className="w-4 h-4 text-veg shrink-0 mt-0.5" />
          Up to {plan.outlet_limit} outlet{plan.outlet_limit > 1 ? "s" : ""}
        </li>
        {PLAN_BENEFITS.slice(0, 3).map((b) => (
          <li key={b} className="flex items-start gap-2"><Check className="w-4 h-4 text-veg shrink-0 mt-0.5" /> {b}</li>
        ))}
      </ul>
      <Button
        onClick={() => onBuy(plan.id)}
        disabled={busy || isCurrent || disabled}
        className="w-full bg-brand-orange hover:bg-[#E65C00] text-white rounded-full"
        data-testid={`buy-${plan.id}`}
      >
        {isCurrent ? "Current plan" : busy ? "Opening…" : `Choose ${sym}${plan.amount}`}
      </Button>
    </Card>
  );
}

export function ContactSalesCard({ email }) {
  return (
    <Card className="p-6 border border-border flex flex-col" data-testid="plan-card-contact">
      <div className="text-xs uppercase tracking-[0.2em] font-bold text-brand-navy mb-2">10+ Outlets</div>
      <div className="font-heading font-extrabold text-3xl">Custom</div>
      <div className="text-xs text-muted-foreground mb-4">Tailored pricing</div>
      <ul className="text-sm space-y-1.5 text-foreground/70 mb-5 flex-1">
        <li className="flex items-start gap-2"><Check className="w-4 h-4 text-veg shrink-0 mt-0.5" /> Volume discount</li>
        <li className="flex items-start gap-2"><Check className="w-4 h-4 text-veg shrink-0 mt-0.5" /> Priority support</li>
        <li className="flex items-start gap-2"><Check className="w-4 h-4 text-veg shrink-0 mt-0.5" /> Dedicated onboarding</li>
      </ul>
      <a href={`mailto:${email}?subject=MenuMojo%20Enterprise%20Plan`}>
        <Button className="w-full bg-brand-navy hover:bg-[#1A2B42] text-white rounded-full" data-testid="contact-sales-btn">
          <Mail className="w-4 h-4" /> Contact sales
        </Button>
      </a>
    </Card>
  );
}

export function EventPlanCard({ plan, busy, disabled, onBuy, sym }) {
  return (
    <Card
      className="p-6 border border-border bg-gradient-to-br from-brand-orange/5 to-transparent flex flex-col md:flex-row gap-6 items-start md:items-center justify-between"
      data-testid={`plan-card-${plan.id}`}
    >
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-brand-orange/10 flex items-center justify-center">
          <CalendarClock className="w-6 h-6 brand-orange" />
        </div>
        <div>
          <div className="font-heading font-bold text-lg">{plan.label}</div>
          <p className="text-sm text-foreground/60 mt-0.5">
            1 menu · {plan.duration_days} days validity · perfect for parties, pop-ups, weddings
          </p>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <div className="font-heading font-extrabold text-3xl brand-orange">{sym}{plan.amount}</div>
        <Button
          onClick={() => onBuy(plan.id)}
          disabled={busy || disabled}
          className="bg-brand-orange hover:bg-[#E65C00] text-white rounded-full"
          data-testid={`buy-${plan.id}`}
        >
          <Sparkles className="w-4 h-4" /> {busy ? "Opening…" : "Get event menu"}
        </Button>
      </div>
    </Card>
  );
}
